import { Text } from '@kanda-libs/ks-design-library';

import Google from '../../../../components/Google';

interface ViewComponentProps {
  /**
   * Disabled state for login button
   */
  disabled?: boolean;
  /**
   * Function to sign in with Google
   */
  signInWithGoogle?: () => unknown;
}

const ViewComponent = ({ disabled, signInWithGoogle }: ViewComponentProps) => (
  <>
    <Text text="Login" className="text-24-28-em mb-10 text-center" />
    <Google socialDisabled={disabled} signInWithGoogle={signInWithGoogle} />
  </>
);

ViewComponent.defaultProps = {
  disabled: undefined,
  signInWithGoogle: undefined,
};

ViewComponent.displayName = 'StaffLogin-Content-view';

export default ViewComponent;
